import { defineProperty as _defineProperty, typeof as _typeof } from '../_virtual/_rollupPluginBabelHelpers.js';
import * as index from './resources/index.js';
import { en } from './resources/en.js';

var _fallback = en;
var activeLanguage = null;

var getBrowserLanguage = function getBrowserLanguage() {
  if (typeof document === "undefined") {
    return "en";
  }

  return document.documentElement.getAttribute("lang") || navigator.language || "en";
}; // convert a flat string with dots as a separator to a deep object
// e.g. ('icon.arrow', 'Some description') is converted to {icon: {arrow: 'Some description'}}


var deepen = function deepen(name, value) {
  return name.split(".").reverse().reduce(function (acc, val) {
    return _defineProperty({}, val, acc);
  }, value);
}; // deep merge of objects
// e.g. ({icons: {arrow: '->'}}, {icons: {info: 'i'}}, {'icons.plus': '+'})
// is converted to {icons: {arrow: '->', info: 'i', plus: '+'}}


var deepMerge = function deepMerge(target) {
  var additionalSources = [];

  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  sources.forEach(function (source) {
    Object.keys(source).forEach(function (key) {
      var sourceValue = source[key];
      var targetValue = target[key];

      if (key.includes(".")) {
        var sourceMerged = deepen(key, sourceValue);
        additionalSources.push(sourceMerged);
      } else if ((targetValue === undefined || _typeof(targetValue) === "object") && _typeof(sourceValue) === "object") {
        target[key] = deepMerge(targetValue || {}, sourceValue);
      } else if (_typeof(targetValue) !== "object" && _typeof(sourceValue) !== "object") {
        target[key] = sourceValue;
      } else ;
    });
  });

  if (additionalSources.length > 0) {
    return deepMerge.apply(void 0, [target].concat(additionalSources));
  }

  return target;
};

var texts = _fallback.texts;
var formats = _fallback.formats;

var getActiveLanguage = function getActiveLanguage() {
  return activeLanguage || getBrowserLanguage();
};

var setLanguage = function setLanguage(lang) {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  activeLanguage = lang;
  var resourceKeyParts = (lang || getBrowserLanguage()).split("-");
  var resourceKeyParent = resourceKeyParts[0];
  var resourceKey = resourceKeyParts.join("_"); // TODO use _.set and _.merge

  texts = deepMerge({}, _fallback.texts, index[resourceKeyParent] && index[resourceKeyParent].texts || {}, index[resourceKey] && index[resourceKey].texts || {}, window.lsgTranslations && window.lsgTranslations.texts || {});
  formats = Object.assign(Object.assign(Object.assign(Object.assign({}, _fallback.formats), index[resourceKeyParent] && index[resourceKeyParent].formats || {}), index[resourceKey] && index[resourceKey].formats || {}), window.lsgTranslations && window.lsgTranslations.formats || {});
};

var getIconTitle = function getIconTitle(name, noDefault) {
  return texts.lsg.icon[name] || !noDefault && texts.lsg.icon._default;
};

var withField = function withField(text, fields) {
  return Object.entries(fields).reduce(function (acc, entry) {
    var searchString = "{{".concat(entry[0], "}}");
    var replaceString = typeof entry[1] === "number" || typeof entry[1] === "string" ? entry[1] : "";
    return acc.replace(searchString, replaceString);
  }, text).replace(/{{.*}}/g, "");
};

setLanguage();

export { formats, getActiveLanguage, getBrowserLanguage, getIconTitle, setLanguage, texts, withField };
